import { api } from '../../../../redux/setupAxios';
import { dateToTimestamp } from '../../../helper';
import { actions } from '.';
import { accumulateObjectValues } from '../helpers/index';
import { merchantActions } from '../../../../redux/merchants';

export const CHECKOUT_URL = 'checkout/sales';
export const USER_URL = 'user/countUser';
export const STATISTIC_URL = 'statistic';
export const POST_URL = 'post';
export const USERS_URL = 'users';
export const SESSIONS_URL = 'sessions';

export async function fetchStatistics({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`${STATISTIC_URL}/all/${merchantId}/${from}/${to}`);
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchSales({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`${CHECKOUT_URL}/${merchantId}/${from}/${to}`);
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchUsers({ merchantId, from, to }, dispatch) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`${USER_URL}/${merchantId}/${from}/${to}`);
		if (dispatch) {
			dispatch(
				actions.updateData({
					users: data,
				})
			);
			dispatch(
				merchantActions.updateLoading({
					isCalendarLoading: false
				}),
			);
		}
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchSession({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`${SESSIONS_URL}/count`, {
			params: {
				merchantId,
				from,
				to,
			},
		});
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchInteractions({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`interactions/count`, {
			params: {
				merchantId,
				from,
				to,
			},
		});
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchWishlist({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now(), true);
	try {
		const { data } = await api.get(`interactions/wishlist`, {
			params: {
				merchantId,
				from,
				to,
			},
		});
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchTopGallery({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now());
	try {
		const { data } = await api.get(`${POST_URL}/topGallery/${merchantId}/${from}/${to}`);
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchTopItems({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now());
	try {
		const { data } = await api.get(`${STATISTIC_URL}/topItem/${merchantId}/${from}/${to}`);
		return data;
	} catch (e) {
		return [];
	}
}

export async function fetchActivity({ merchantId, from, to }) {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now());
	try {
		const { data } = await api.get(`${STATISTIC_URL}/activity/${merchantId}/${from}/${to}`);
		return data;
	} catch (e) {
		return [];
	}
}

export async function updateAll(filter, dispatch) {
	dispatch(actions.updateLoading(true));
	const allStatistics = await fetchStatistics(filter);
	const sales = await fetchSales(filter);
	dispatch(
		merchantActions.updateLoading({
			isCalendarLoading: false
		}),
	);
	if (!allStatistics || !allStatistics.length) {
		dispatch(
			actions.resetState(),
		);
	}
	let metricsTotals = {
		Users: 0,
		Sessions: 0,
		Posts: 0,
		Sales: 0,
		Interactions: 0,
	};
	const usersCounted = getTotalUsers(allStatistics);

	allStatistics.forEach((stat) => {
		metricsTotals = {
			Users: accumulateObjectValues(usersCounted.newUserCountByType),
			// accept 'sessions' or 'Sessions'
			Sessions: metricsTotals.Sessions += stat.metrics.sessions || stat.metrics.Sessions || 0,
			Posts: metricsTotals.Posts += accumulateObjectValues(stat.metrics.Posts),
			Interactions: metricsTotals.Interactions += accumulateObjectValues(stat.metrics.Interactions),
			usersByType: usersCounted.newUserCountByType
		}
	});
	dispatch(
		actions.updateSales({
			sales
		}),
	);
	dispatch(
		actions.updateData({ statistics: allStatistics, metricsTotals })
	);
}
const getTotalUsers = (allStatistics) => {
	const usersTypes = ['guest', 'signed', 'guestWithName']
	const dailyNewUsers = allStatistics.map((val) => {
		return {
			...val.metrics.Users?.new,
		}
	})
	const newUserCountByType = {
		guest: 0,
		signed: 0
	};
	usersTypes.forEach((type) => {
		dailyNewUsers.reduce((a, b) => {
			if (type !== 'signed') {
				newUserCountByType.guest += b[type] || 0;
			} else {
				newUserCountByType.signed += b[type] || 0;
			}
			return a + (b[type] || 0)
		}, 0);
	});
	return { newUserCountByType };
}
